import { useEffect, useState } from 'react'
import { SuggestionMenuProps } from '@blocknote/react'

import {
  BorderRadius4,
  BorderRadius8,
  GreyGrey20,
  GreyGrey30,
  GreyGrey40,
  GreyGrey80,
  GreyWhite,
  Primary13Regular,
  Center,
  Box,
  Grid
} from '@sequencehq/core-components'
import { getCustomSuggestionMenuItems } from 'modules/Cube/view/layouts/quote/QuoteEditorContent/ContentEditor/CustomSuggestionMenu/menuItems'
import { SuggestionItem } from './types'
import { blocknoteSchema } from '../blocknoteSchema'

export const CustomSuggestionMenu = (
  props: SuggestionMenuProps<SuggestionItem> & {
    'data-testid': string
    editor: typeof blocknoteSchema.BlockNoteEditor
    addPhaseBlockEnabled: boolean
  }
) => {
  const [isMouseOver, setIsMouseOver] = useState<boolean>(false)
  const allMenuItems = getCustomSuggestionMenuItems(
    props.editor,
    props.addPhaseBlockEnabled
  )

  useEffect(() => {
    setIsMouseOver(false)
  }, [props.selectedIndex])

  if (props.items.length === 0) {
    return null
  }

  const showSeparatorAfter = ['Paragraph', 'Numbered list', 'Pricing']

  return (
    <Box
      data-testid={`content-editor.custom-suggestion-menu.${props['data-testid']}`}
      borderRadius={BorderRadius8}
      border={`1px solid ${GreyGrey40}`}
      width="220px"
      padding="4px"
      boxShadow="0px 8px 16px 0px rgba(0, 0, 0, 0.08)"
      backgroundColor={GreyWhite}
      onMouseMove={() => setIsMouseOver(true)}
      onMouseOut={() => setIsMouseOver(false)}
    >
      {props.items.map((item, index) => {
        const disabled = item.title === 'Pricing' && !props.addPhaseBlockEnabled

        const showSeparator =
          showSeparatorAfter.includes(item.title) &&
          props.items.length === allMenuItems.length

        const labelFont = item.font ?? Primary13Regular

        return (
          <>
            <Grid
              key={item.title}
              data-testid={`content-editor.custom-suggestion-menu.items.${slugify(item.title)}`}
              gridTemplateColumns={item.icon ? '16px 1fr' : '1fr'}
              height="32px"
              padding="8px"
              borderRadius={BorderRadius4}
              alignItems="center"
              gap="8px"
              width="100%"
              onClick={() => !disabled && props.onItemClick?.(item)}
              {...(isMouseOver && {
                _hover: { cursor: 'pointer', backgroundColor: GreyGrey20 }
              })}
              {...(index === props.selectedIndex &&
                !isMouseOver && { background: GreyGrey20 })}
              {...(disabled && { opacity: 0.5 })}
            >
              {item.icon && <Center color={GreyGrey80}>{item.icon}</Center>}
              <Box {...labelFont} color={GreyGrey80}>
                {item.title}
              </Box>
            </Grid>

            {showSeparator && (
              <Box
                width="calc(100% + 8px)"
                position="relative"
                left="-4px"
                height="1px"
                background={GreyGrey30}
                marginY="4px"
              />
            )}
          </>
        )
      })}
    </Box>
  )
}

const slugify = (text: string): string => text.toLowerCase().replace(/ /g, '-')
